import { render, staticRenderFns } from "./ProveedoresListado.vue?vue&type=template&id=0685c834"
import script from "./ProveedoresListado.vue?vue&type=script&lang=js"
export * from "./ProveedoresListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports